import React, { Fragment } from "react";

const TimeOutUser = ({ timed_out_user, unTimeoutUser }) => {
  return (
    <Fragment>
      <div className="report-item">
        <div className="user-section-alt grey">
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div
                className={`avi-color-border ${
                  timed_out_user && timed_out_user.role === "innovator"
                    ? "green"
                    : timed_out_user && timed_out_user.role === "mentor"
                    ? "red"
                    : timed_out_user && timed_out_user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${timed_out_user.avatar}`}
                  className="friend-user-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span
                      className={`${
                        timed_out_user && timed_out_user.role === "innovator"
                          ? "green"
                          : timed_out_user && timed_out_user.role === "mentor"
                          ? "red"
                          : timed_out_user && timed_out_user.role === "employer"
                          ? "blue"
                          : ""
                      } name-font`}
                    >
                      {timed_out_user.channelid}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {timed_out_user.firstname} {timed_out_user.lastname}
                  </li>
                  <li className="user-online-item">
                    {timed_out_user.jobtitle}
                  </li>
                  <li className="user-online-item">
                    {timed_out_user.location && timed_out_user.location.state},{" "}
                    {timed_out_user.location && timed_out_user.location.country}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                onClick={() => unTimeoutUser(timed_out_user.channelid)}
                className={`setting-friend-button ${
                  timed_out_user && timed_out_user.role === "innovator"
                    ? "background-green"
                    : timed_out_user && timed_out_user.role === "mentor"
                    ? "background-red"
                    : timed_out_user && timed_out_user.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-hourglass-end mx-5"></i>
                Untimeout
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TimeOutUser;
